var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMsgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0903 12.4193L7.72077 11.6299C5.24061 10.8035 4 10.3903 4 9.63033C4 8.87142 5.24061 8.45718 7.72077 7.63081L16.6938 4.63944C18.4393 4.05761 19.3121 3.7667 19.7727 4.22731C20.2333 4.68793 19.9424 5.56068 19.3616 7.30512L16.3692 16.2792C15.5428 18.7594 15.1296 20 14.3697 20C13.6108 20 13.1965 18.7594 12.3701 16.2792L11.5796 13.9108L16.1689 9.3215C16.3609 9.1227 16.4672 8.85645 16.4648 8.58008C16.4624 8.30372 16.3515 8.03935 16.1561 7.84392C15.9606 7.64849 15.6963 7.53764 15.4199 7.53524C15.1435 7.53284 14.8773 7.63908 14.6785 7.83108L10.0903 12.4193Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMsgIcon);
export default __webpack_public_path__ + "static/media/send-msg-icon.5b65451024329a1a9168466cc436aaff.svg";
export { ForwardRef as ReactComponent };